import Integration from './IntegrationContainer.vue';

export { Integration };



// WEBPACK FOOTER //
// ./src/modules/home/integration/index.js